import React from "react";
import SearchPanel from "../Other/Search/SearchPannel";
import GuaranteedHero from "./GuaranteedHero";

const Guaranteed = () => {
  return (
    <div className="mt-24">
        <GuaranteedHero/>
        <SearchPanel/>
    </div>
  );
};

export default Guaranteed;